import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/office.png'
import _imports_1 from '@/assets/Gmail-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-39206958"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fab-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"fab shadow\" data-v-39206958><div class=\"fab-content\" data-v-39206958><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-layers-fill\" viewBox=\"0 0 16 16\" data-v-39206958><path d=\"M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882l7.5-4z\" data-v-39206958></path><path d=\"m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0z\" data-v-39206958></path></svg></div></div><div class=\"sub-button shadow\" data-v-39206958><a href=\"https://www.office.com/launch/word\" target=\"_blank\" title=\"Word\" data-v-39206958><img src=\"" + _imports_0 + "\" alt=\"word\" class=\"logo-image\" data-v-39206958></a></div>", 2)
const _hoisted_4 = { class: "sub-button shadow" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chat",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894m-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-button shadow" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.google.com/intl/es/gmail/about/",
    target: "_blank",
    title: "Gmail"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "word",
      class: "logo-image"
    })
  ])
], -1))
const _hoisted_8 = { class: "sub-button shadow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upc",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]

import ReportButtom from './ReportButtom.vue';
import DeviceC from './DeviceC.vue';
import {ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingTools',
  setup(__props) {

let CardReport = ref(false);
const ReportOpen=()=>{
    CardReport.value = !CardReport.value
}

function updatePropsValue(newValue:boolean){
    CardReport.value = newValue
}

//emits y props de DeviceC------------------------------
let device = ref(false);
const deviceOpen = () =>{
    device.value =!device.value
}

function updatePropsD(newValue:boolean){
    device.value = newValue
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ReportButtom, {
      CardReport: _unref(CardReport),
      onUpdateProps: updatePropsValue
    }, null, 8, ["CardReport"]),
    _createVNode(DeviceC, {
      device: _unref(device),
      onDevicesProps: updatePropsD
    }, null, 8, ["device"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: "#",
          onClick: _withModifiers(ReportOpen, ["prevent"])
        }, _hoisted_6)
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          href: "#",
          onClick: _withModifiers(deviceOpen, ["prevent"])
        }, _hoisted_10)
      ])
    ])
  ], 64))
}
}

})